import { createSelector } from '@reduxjs/toolkit';
import { TargetGroupState, targetGroupAdapter } from 'components/pages/console/store/TargetGroupSlice';
import { TargetGroup } from 'gql/TargetGroup';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';

const selectSelf = (state: RootState): TargetGroupState => {
  return state.targetGroup;
};

const selectTargetGroupState = createSelector(selectSelf, (state: TargetGroupState): ActionStatus => {
  return state.loadingState.status;
});

const selectTargetGroupStarted = createSelector(selectSelf, (state: TargetGroupState): boolean => {
  return state.loadingState.status !== ActionStatus.IDLE;
});

const selectTargetGroupProcessing = createSelector(selectSelf, (state: TargetGroupState): boolean => {
  return state.loadingState.status === ActionStatus.PROCESSING;
});

const selectTargetGroups = createSelector(selectSelf, (state: TargetGroupState): TargetGroup[] => {
  return targetGroupAdapter.getSelectors().selectAll(state.targetGroups);
});

const selectTargetGroup = createSelector(selectSelf, (state: TargetGroupState): TargetGroup | undefined => {
  return state.targetGroup;
});

const selectCreateProcessing = createSelector(selectSelf, (state: TargetGroupState): boolean => {
  return state.mutationState.status === ActionStatus.PROCESSING;
});

const selectCreateTargetGroupId = createSelector(selectSelf, (state: TargetGroupState): string | undefined => {
  return state.mutatedTargetGroupId;
});

const selectCreateSucceeded = createSelector(selectSelf, (state: TargetGroupState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

const selectUpdateProcessing = createSelector(selectSelf, (state: TargetGroupState): boolean => {
  return state.mutationState.status === ActionStatus.PROCESSING;
});

const selectUpdateSucceeded = createSelector(selectSelf, (state: TargetGroupState): boolean => {
  return state.mutationState.status === ActionStatus.SUCCEEDED;
});

const selectUpdateTargetGroupId = createSelector(selectSelf, (state: TargetGroupState): string | undefined => {
  return state.mutatedTargetGroupId;
});

const TargetGroupSelectors = {
  selectTargetGroupState,
  selectTargetGroupStarted,
  selectTargetGroupProcessing,
  selectTargetGroups,
  selectTargetGroup,
  selectCreateProcessing,
  selectCreateTargetGroupId,
  selectCreateSucceeded,
  selectUpdateProcessing,
  selectUpdateTargetGroupId,
  selectUpdateSucceeded,
};

export default TargetGroupSelectors;
